/**
 * Shared API Client Instances
 *
 * Provides singleton instances of generated API clients.
 * Uses the base URL from environment configuration.
 */

import {
  AssignmentDefinitionsClient,
  AuthClient,
  CertificatesClient,
  CertificateTemplatesClient,
  CourseAuthorsClient,
  CourseCustomFieldsClient,
  CourseDetailTabsClient,
  CourseEnrollmentsClient,
  CoursesClient,
  GroupsClient,
  LearnerProfileClient,
  LessonCompletionsClient,
  LessonsClient,
  ModulesClient,
  NotificationsClient,
  ProfessionsClient,
  QuizClient,
  ReferenceFieldsClient,
  ReportsClient,
  StorageClient,
  TagsClient,
  UserAssignmentsClient,
  UsersClient,
  WorkspacesClient,
} from './api-client';

console.log(process.env.REACT_APP_API_BASE_URL);
const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://localhost:44313';


export const authClient = new AuthClient(baseUrl);
export const coursesClient = new CoursesClient(baseUrl);
export const lessonsClient = new LessonsClient(baseUrl);
export const lessonCompletionsClient = new LessonCompletionsClient(baseUrl);
export const notificationsClient = new NotificationsClient(baseUrl);
export const storageClient = new StorageClient(baseUrl);
export const usersClient = new UsersClient(baseUrl);
export const enrollmentsClient = new CourseEnrollmentsClient(baseUrl);
export const workspacesClient = new WorkspacesClient(baseUrl);
export const assignmentDefinitionsClient = new AssignmentDefinitionsClient(baseUrl);
export const userAssignmentsClient = new UserAssignmentsClient(baseUrl);
export const tagsClient = new TagsClient(baseUrl);
export const modulesClient = new ModulesClient(baseUrl);
export const groupsClient = new GroupsClient(baseUrl);
export const quizClient = new QuizClient(baseUrl);
export const courseDetailTabsClient = new CourseDetailTabsClient(baseUrl);
export const certificatesClient = new CertificatesClient(baseUrl);
export const certificateTemplatesClient = new CertificateTemplatesClient(baseUrl);
export const reportsClient = new ReportsClient(baseUrl);
export const courseAuthorsClient = new CourseAuthorsClient(baseUrl);
export const courseCustomFieldsClient = new CourseCustomFieldsClient(baseUrl);
export const professionsClient = new ProfessionsClient(baseUrl);
export const referenceFieldsClient = new ReferenceFieldsClient(baseUrl);
export const learnerProfileClient = new LearnerProfileClient(baseUrl);
